import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { LoadableResponsiveImage as ResponsiveImage } from '../../../components/ResponsiveImage/LoadableResponsiveImage';
import { Carousel } from '../Carousel/Carousel';
import { ellipsis } from '../../../utilities/string-extensions';
import { stripHtml } from '../../../utilities/utilities';

// eslint-disable-next-line react/prefer-stateless-function
export class PortalTeamCarousel extends React.Component {
  static propTypes = {
    teamData: ImmutablePropTypes.listOf(
      ImmutablePropTypes.mapContains({
        fullName: PropTypes.string.isRequired,
        profileName: PropTypes.string.isRequired,
        profileLink: PropTypes.string.isRequired,
        'avatar@3x': PropTypes.string.isRequired,
        profileSummary: PropTypes.string.isRequired,
      })
    ).isRequired,
    defaultProfileSummary: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
  };

  render() {
    const { teamData, defaultProfileSummary, width } = this.props;
    const minSize = 210;
    const carouselSize = Math.max(Math.floor(width / minSize), 1);

    return (
      <Carousel
        slidesToShow={carouselSize}
        slidesToScroll={carouselSize}
        key={`carousel${carouselSize}`}
      >
        {teamData.map((teamMember) => {
          const profileSummaryCharLimit = 160;
          const profileSummary = ellipsis(
            stripHtml(teamMember.get('profileSummary')),
            profileSummaryCharLimit
          );

          return (
            <div
              className="team-member-container"
              key={teamMember.get('profileName')}
            >
              <a href={teamMember.get('profileLink')}>
                <ResponsiveImage
                  src={teamMember.get('avatar@3x')}
                  resize="h:100,w:100"
                />
              </a>
              <div className="team-member-summary-container">
                <h5>
                  <a href={teamMember.get('profileLink')}>
                    {teamMember.get('fullName')}
                  </a>
                </h5>
                <h5>{profileSummary || defaultProfileSummary}</h5>
              </div>
            </div>
          );
        })}
      </Carousel>
    );
  }
}
